import axios from "axios";

const apiPublic = axios.create({
  baseURL: process.env.VUE_APP_API,
  headers: {
    "Content-Type": "application/json",
    "X-Api-Key": process.env.VUE_APP_API_KEY,
  },
});

export const getOperadoresPublic = async () => {
  const response = await apiPublic.get('public/operadores/');
  return response.data;
};

export const getMaquinasPublic = async () => {
  const response = await apiPublic.get('public/catalogo-maquinas/');
  return response.data;
};

export const getProductosPublic = async () => {
  const response = await apiPublic.get('public/catalogo-productos/');
  return response.data;
};

export const getPigmentosPublic = async () => {
  const response = await apiPublic.get('public/colores/');
  return response.data;
};

/**
 * Envía el formulario de Vena y Scrap al back.
 * Recibe el payload ya construido por buildPayload() del composable.
 *
 * Payload esperado:
 * {
 *     "tipo_reporte": "vena_scrap",
 *     "fecha_registro": "2026-06-28T05:37:54.903Z",
 *     "fecha": "2026-06-27",
 *     "id_operador": 12,
 *     "id_maquina": 1,
 *     "id_producto": 8,
 *     "id_color": 19,
 *     "aditivo": true,
 *     "venaKg": 55,
 *     "scrapKg": 60,
 *     "comentarios": "Comentarios"
 * }
 *
 * @param {object} payload — resultado de buildPayload()
 * @returns {object} — registro creado (VenaScrapDetalleSerializer)
 */
export const crearVenaScrap = async (payload) => {
  const response = await apiPublic.post(
    "formularios/vena-scrap/",
    payload
  );
  return response.data;
};

/**
 * Descarga el Excel de consumos de vena y scrap en el rango de fechas dado.
 * Requiere fecha_inicio y fecha_fin en formato YYYY-MM-DD.
 * Usa la instancia autenticada (JWT) porque es un endpoint del admin.
 *
 * @param {string} fechaInicio — YYYY-MM-DD
 * @param {string} fechaFin    — YYYY-MM-DD
 */
export const exportarConsumoVenaScrap = async (fechaInicio, fechaFin) => {
  const { api } = await import("./api_backend");
 
  const response = await api.get("exportar/vena-scrap/", {
    params: { fecha_inicio: fechaInicio, fecha_fin: fechaFin },
    responseType: "blob",
  });
 
  const url  = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href  = url;
  link.setAttribute("download", `consumo_vs_${fechaInicio}_a_${fechaFin}.xlsx`);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

// ─────────────────────────────────────────────────────────────────
// Analítica / Dashboard de mermas — agregados que vienen ya
// procesados con pandas/numpy del lado del backend (ver
// analitica_vena_scrap.py). Usan la instancia autenticada (JWT)
// porque alimentan el dashboard interno, no un formulario público.
// ─────────────────────────────────────────────────────────────────

/**
 * Totales de vena/scrap agrupados por máquina, para la gráfica de barras
 * del dashboard de mermas.
 *
 * @param {object} params - { fecha_inicio, fecha_fin, maquinas }
 *   fecha_inicio / fecha_fin: YYYY-MM-DD (requeridos)
 *   maquinas: string de ids separados por coma (ej. "1,2,4"), o "" para todas
 * @returns {Array} [{ maquina, scrap, vena }]
 */
export const getVenaScrapPorMaquina = async (params) => {
  const { api } = await import("./api_backend");
  const response = await api.get("analitica/vena-scrap/por-maquina/", { params });
  return response.data;
};

/**
 * Histórico mensual de vena/scrap (todos los meses con registros), para
 * la tabla de totales del dashboard de mermas.
 *
 * @param {object} params - { maquinas }
 *   maquinas: string de ids separados por coma (ej. "1,2,4"), o "" para todas
 * @returns {Array} [{ periodo: { inicio, fin }, scrap, vena, total }]
 */
export const getVenaScrapTotalesMensuales = async (params) => {
  const { api } = await import("./api_backend");
  const response = await api.get("analitica/vena-scrap/totales-mensuales/", { params });
  return response.data;
};